import { Component, Input } from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
    selector: 'lib-icon-toggle-button',
    templateUrl: "../icon-button/icon-button.component.html",
})
export class ToggleButtonComponent<T> extends IconButtonComponent {
    @Input() value!: T;
}
